import { combineReducers } from 'redux';

import data from './data';
import params from './params';

export default combineReducers({ data, params });
